import { Button, Grid, Typography } from '@mui/material';

/**
 * Shown when the app cannot reach the server during startup.
 *
 * Deliberately NOT the sign-in screen: a transport failure says nothing about
 * whether the session is valid, and sending the user to sign in here is what made
 * a brief connection drop look like being logged out. The stored tokens are left
 * untouched so a retry resumes the existing session.
 */
const BootRetry = ({ onRetry }) => {
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ height: '100vh', padding: '24px', textAlign: 'center', gap: '12px' }}
    >
      <Typography sx={{ fontSize: '18px', fontWeight: 600 }}>
        Can&apos;t reach the server
      </Typography>
      <Typography sx={{ fontSize: '14px', opacity: 0.7, maxWidth: '320px' }}>
        Check your internet connection and try again. You are still signed in.
      </Typography>
      <Button variant="contained" onClick={onRetry} sx={{ marginTop: '8px' }}>
        Retry
      </Button>
    </Grid>
  );
};

export default BootRetry;
